import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateOrderZipaQuotation } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateOrderZipaQuotation() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ orderId, zipaWorldQuotationId }: { orderId: string; zipaWorldQuotationId: string }) =>
      updateOrderZipaQuotation(orderId, zipaWorldQuotationId, accessToken!),
    onSuccess: (_, variables) => {
      // Invalidate the specific order queries to trigger reload
      queryClient.invalidateQueries({ queryKey: ["buyer-orders"] })
      queryClient.invalidateQueries({ queryKey: ["buyer-order-detail", variables.orderId] })
    },
  })
}
